// extracted by mini-css-extract-plugin
module.exports = {"accordionSummary":"styles_accordionSummary__1mS3B","titleCotainer":"styles_titleCotainer__1VDdG","title":"styles_title__2MmQH"};